import instance from "../../../helpers/AxiosInterceptor";

export const listCoeffAbattEv = () => {
    return instance.get(`/settings/coefev/list`);
};

export const findCoeffAbattEv = (id) => {
    return instance.get(`/settings/coefev/find/${id}`);
};

export const createCoeffAbattEv = (request) => {
    return instance.post(`/settings/coefev/create`, JSON.stringify(request));
};

export const updateCoeffAbattEv = (request) => {
    return instance.put(`/settings/coefev/update`, JSON.stringify(request));
};
